import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpandSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconExpandSimple"><Path fillRule="evenodd" clipRule="evenodd" d="M12 5H19V12H17V7H12V5ZM7 12V17H12V19H5V12H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpandSimple;
